import { useMemo } from 'react';
import { AuthUserType } from '../auth/types';

/**
 * Custom hook that derives allowed navigation titles based on the user's role.
 */
export const useAllowedNavItems = (user?: AuthUserType) => {
  return useMemo(() => {
    const roleId = user?.roleId;

    const isReceptionist = roleId === 'assistant' || roleId === 'receptionist';
    const isClinician = roleId === 'professional' || roleId === 'clinician';
    const isManager = roleId === 'manager' || roleId === 'accountant';
    const isMarketing = roleId === 'marketing';

    let allowedTitles: string[] | null = null;

    switch (true) {
      case roleId === 'patient':
        allowedTitles = ['patient', 'dispense', 'till'];
        break;
      case isReceptionist:
        allowedTitles = ['diary', 'patient'];
        break;
      case isClinician:
        allowedTitles = ['diary', 'patient'];
        break;
      case isManager:
        allowedTitles = ['patient', 'reporting'];
        break;
      case isMarketing:
        allowedTitles = ['recalls', 'patient'];
        break;
      default:
        allowedTitles = null; // Admin or unknown role -> show all
        break;
    }

    return allowedTitles;
  }, [user?.roleId]);
};

/**
 * Derive allowed route root segments from the same role mapping logic.
 * Keep centralized and simple: one place to adjust role-based permissions.
 */
export const useAllowedRouteRoots = (user?: AuthUserType) => {
  return useMemo(() => {
    const roleId = user?.roleId;

    const isReceptionist = roleId === 'assistant' || roleId === 'receptionist';
    const isClinician = roleId === 'professional' || roleId === 'clinician';
    const isManager = roleId === 'manager' || roleId === 'accountant';
    const isMarketing = roleId === 'marketing';

    let allowedRoots: string[] | null = null;

    switch (true) {
      case roleId === 'patient':
        allowedRoots = ['patients', 'dispense', 'till', 'settings'];
        break;
      case isReceptionist:
        allowedRoots = ['diary', 'patients','settings'];
        break;
      case isClinician:
        allowedRoots = ['diary', 'patients','settings'];
        break;
      case isManager:
        allowedRoots = ['patients', 'reporting','settings'];
        break;
      case isMarketing:
        allowedRoots = ['recalls', 'patients','settings'];
        break;
      default:
        allowedRoots = null; // Admin or unknown role -> all allowed
        break;
    }

    return allowedRoots;
  }, [user?.roleId]);
};
